__webpack_require__.p = "/Pokemon-UI-API/";